
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppManagerTreeNodeViewContentDirectoryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"treeNodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"treeNodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"treeNodeId"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppManagerTreeNodeViewContentDirectorySpotsFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppManagerTreeNodeViewContentDirectoryGatewaysFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoreTreeNodeContentHeaderFragment"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppManagerTreeNodeViewContentDirectorySpotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotAggregate"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainUiSpotSummaryPanelCollectionFragment"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppManagerTreeNodeViewContentDirectoryGatewaysFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GatewayAggregate"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateways"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainUiGatewaySummaryPanelCollectionFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":851}};
    doc.loc.source = {"body":"#import \"@/features/core/components/tree-node-content-header/tree-node.gql\"\n#import \"@/features/domain-ui/gateway-summary-panel/collection.gql\"\n#import \"@/features/domain-ui/spot-summary-panel/collection.gql\"\n\nquery AppManagerTreeNodeViewContentDirectoryQuery($treeNodeId: ID!, $userId: ID) {\n  treeNodes(ids: [$treeNodeId]) {\n    first {\n      id\n      ...AppManagerTreeNodeViewContentDirectorySpotsFragment\n      ...AppManagerTreeNodeViewContentDirectoryGatewaysFragment\n      ...CoreTreeNodeContentHeaderFragment\n    }\n  }\n}\n\nfragment AppManagerTreeNodeViewContentDirectorySpotsFragment on SpotAggregate {\n  spots(userId: $userId) {\n    ...DomainUiSpotSummaryPanelCollectionFragment\n  }\n}\n\nfragment AppManagerTreeNodeViewContentDirectoryGatewaysFragment on GatewayAggregate {\n  gateways {\n    ...DomainUiGatewaySummaryPanelCollectionFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/features/core/components/tree-node-content-header/tree-node.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/features/domain-ui/gateway-summary-panel/collection.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/features/domain-ui/spot-summary-panel/collection.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AppManagerTreeNodeViewContentDirectoryQuery"] = oneQuery(doc, "AppManagerTreeNodeViewContentDirectoryQuery");
        
        module.exports["AppManagerTreeNodeViewContentDirectorySpotsFragment"] = oneQuery(doc, "AppManagerTreeNodeViewContentDirectorySpotsFragment");
        
        module.exports["AppManagerTreeNodeViewContentDirectoryGatewaysFragment"] = oneQuery(doc, "AppManagerTreeNodeViewContentDirectoryGatewaysFragment");
        
